import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { CONTACT } from "../data/content";

export default function Footer() {
  return (
    <footer className="bg-navy text-slate-300" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:grid-cols-2 sm:px-6 lg:grid-cols-4 lg:px-8">
        <div className="space-y-4">
          <img
            src="/assets/eef-logo.webp"
            alt="The Experiential Education Foundation logo"
            className="h-14 w-auto"
            data-testid="footer-foundation-logo"
          />
          <div className="inline-block rounded-md bg-white px-3 py-2.5">
            <img src="/assets/casia-logo.webp" alt="CASIA logo" className="h-9 w-auto" />
          </div>
          <p className="text-xs leading-relaxed text-slate-400">
            CASIA, Centre for Applied Studies &amp; Immersive Academics is the flagship school-facing initiative of The
            Experiential Education Foundation, a registered non-profit educational foundation.
          </p>
        </div>

        <nav aria-label="Footer" className="space-y-3">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold">Explore</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="transition-colors hover:text-white" data-testid="footer-nav-home">Home</Link></li>
            <li><Link to="/learning-journey" className="transition-colors hover:text-white" data-testid="footer-nav-learning-journey">Learning Journey</Link></li>
            <li><Link to="/about" className="transition-colors hover:text-white" data-testid="footer-nav-about">About</Link></li>
            <li><Link to="/contact" className="transition-colors hover:text-white" data-testid="footer-nav-contact">Contact Us</Link></li>
          </ul>
        </nav>

        <div className="space-y-3">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold">Contact</p>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2">
              <Phone className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" />
              <a href="tel:+918428255599" className="transition-colors hover:text-white" data-testid="footer-phone-chennai">
                Chennai {CONTACT.chennai}
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" />
              <a href="tel:+919071655599" className="transition-colors hover:text-white" data-testid="footer-phone-bangalore">
                Bangalore {CONTACT.bangalore}
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" />
              <a href={`mailto:${CONTACT.email}`} className="transition-colors hover:text-white" data-testid="footer-email">
                {CONTACT.email}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <p className="mx-auto max-w-7xl px-4 py-5 text-xs text-slate-500 sm:px-6 lg:px-8">
          © {new Date().getFullYear()} The Experiential Education Foundation. CASIA, Centre for Applied Studies &amp;
          Immersive Academics.
        </p>
      </div>
    </footer>
  );
}
